import api from "../api/client";

const qualPApi = {

  postQualP(payload, idShipper) {

    return api.post("/qualp/routes", payload, {
      params: {
        uidShipper: idShipper,
      },
    });
  },

  createFreightFromSimulation(payload) {
    return api.post("/CreateFreightFromSimulationController/v1", payload);
  },

  calculateGrossFreightProposedByShipper(payload) {
    return api.post("CreateFreightFromSimulationController/calculateGrossFreightProposedByShipper/v1", payload);
  }
};

export default qualPApi;
